export const transformLoanApplicationData = (payload: any, currency: string) => {
  const {
    fullName,
    surname,
    reasons,
    phone,
    acquisitionPartnerProductId,
    carManufacturingYear,
    whatsappType,
    tinNumber,
    tradeAssociation,
    tinType,
    reason,
    otherReasonForLoanText,
    numberOfEmployees,
    numOfChildren,
    nextOfKinPhone,
    nextOfKinName,
    nextOfKinPhoneCode,
    maritalStatus,
    amount,
    levelOfEducation,
    periodWithNoIncome,
    otherIncomeSourceAmount,
    housingSituationText,
    numFinancialSupport,
    periodUsingCellPhoneText,
    dateOfBirth,
    gender,
    yearBusinessStarted,
    numOfCellPhonesOwned,
    currentMomoBalance,
    currentBankBalance,
    businessAddress,
    businessDescription,
    businessLocation,
    businessName,
    cacNumber,
    email,
    bankVerificationNumber,
    consent,
    repaymentMonths
  } = payload;

  const { ownsACar, hasOtherBusiness } = payload;

  let haveOtherIncomeSource = false;
  let ownACar = false;

  haveOtherIncomeSource = hasOtherBusiness && hasOtherBusiness === "Yes";
  ownACar = ownsACar && ownsACar === "Yes";

  let reasonIds = [];

  if (reasons && reasons.length) {
    reasonIds = reasons?.map((id) => ({ id }));
  }

  const userFormData = {
    fullName,
    dateOfBirth,
    maritalStatus,
    gender,
    levelOfEducation,
    numOfChildren,
    nextOfKinName,
    emergencyPhoneNo: `${nextOfKinPhoneCode}${nextOfKinPhone}`,
    businessDescription,
    businessName,
    businessLocation,
    businessAddress,
    bankVerificationNumber,
    yearBusinessStarted,
    extras: {
      levelOfEducation,
      yearBusinessStarted,
      cacNumber,
      gender,
      businessDescription,
      businessName,
      businessLocation,
      nextOfKinName,
      bankVerificationNumber,
      fullName,
      emergencyPhoneNo: `${nextOfKinPhoneCode}${nextOfKinPhone}`,
      dateOfBirth,
      numOfChildren,
      businessAddress,
      maritalStatus,
      reason,
      otherReasonForLoanText,
    },
    consent,
    repaymentMonths
  };

  const formData = {
    amount: parseFloat(amount),
    currency,
    acquisitionPartnerProductId,
    customerAccNo: "",
    bankCode: "",
    surname,
    email,
    fullName,
    mobilePhoneNo: phone,
    firstName: userFormData.fullName.split(" ")[0],
    bvn: bankVerificationNumber,
    financialInfo: {
      currentMomoBalance,
      currentBankBalance,
      haveOtherIncomeSource,
      otherIncomeSourceCurrency: currency,
      otherIncomeSourceAmount,
      periodWithNoIncome,
      numFinancialSupport,
      reason,
      otherReasonForLoanText,
    },
    indexedBorrower: userFormData,
    otherInfo: {
      ownACar,
      carManufacturingYear,
      whatsappType,
      numOfCellPhonesOwned,
      periodUsingCellPhoneText,
      housingSituationText,
      tinNumber,
      tinType,
      tradeAssociation,
      numberOfEmployees,
    },
    reason,
    otherReasonForLoanText,
    reasons: reasonIds,
    extras: {
      nextOfKinPhoneCode,
      nextOfKinPhone,
      repaymentMonths
    },
    consent
  };

  return { userFormData, formData };
};

export const transformSavedLoanData = (data: any) => {
  const flattenedObj = {};

  const flattenObject = (obj: Record<string, any>) => {
    if (!obj) return;
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === "object") {
        if (key === "periodUsingCellPhone" || key === "housingSituation") {
          flattenedObj[key] = obj[key].id;
        } else if (key === "reasons") {
          flattenedObj[key] = obj[key]?.map((reason) => reason.id + "");
        } else {
          flattenObject(obj[key]);
        }
      } else {
        flattenedObj[key] = obj[key];
      }
    });
  };

  flattenObject(data);
  return flattenedObj;
};
